import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ElmMatFormContentModule } from '@element451-libs/components451/mat-form-content';
import {
  ElmButtonToggleComponent,
  ElmButtonToggleGroupComponent
} from './elm-button-toggle-group.component';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    ElmMatFormContentModule
  ],
  exports: [ElmButtonToggleComponent, ElmButtonToggleGroupComponent],
  declarations: [ElmButtonToggleComponent, ElmButtonToggleGroupComponent]
})
export class ElmButtonToggleGroupModule {}
